import React from 'react';
import {} from 'material-ui';
import R from 'ramda';
import ExpandableTextBlock from '../../../tc-ui/expandable-text-block';

export default ({ diffWords, lhs, rhs, isLeft }) => {
  const text = isLeft ? lhs : rhs;
  if (diffWords && !R.isEmpty(diffWords)) {
    return (
      <span>
        {
          diffWords
          .filter(word => (!word.added && isLeft) || (!word.removed && !isLeft))
          .map((word, wordIndex) => {
            const className = (() => {
              if (word.removed && isLeft) return 'diff-deleted';
              if (word.added && !isLeft) return 'diff-added';
            })();
            return <span key={wordIndex} className={className}>{word.value}</span>;
          })
        }
      </span>
    )
  }
  return (
    <ExpandableTextBlock className={isLeft ? 'diff-deleted' : 'diff-added'}>
    {text}
    </ExpandableTextBlock>);
};





// WEBPACK FOOTER //
// ./src/app/components/contracting-reports/diff-report/diffing/text-dff.jsx